/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParcelLpisIntersect } from './parcelLpisIntersect.model';
import { ParcelOwnershipJuristicTypeEntity } from './parcelOwnershipJuristicTypeEntity.model';
import { ParcelGroup } from './parcelGroup.model';


export interface ParcelListDto { 
    budId?: number;
    cislNazev?: string;
    drupozNazev?: string;
    endDate?: string;
    id?: number;
    katuzeNazev?: string;
    krajNazev?: string;
    lv?: number;
    obecNazev?: string;
    okresNazev?: string;
    parId?: number;
    parType?: string;
    parcelGroups?: Array<ParcelGroup>;
    parcelLpisIntersect?: ParcelLpisIntersect;
    parcelOwnershipJuristicTypes?: Array<ParcelOwnershipJuristicTypeEntity>;
    parcis?: string;
    parcisDil?: number;
    startDate?: string;
    vymera?: number;
    zastavenaVymera?: number;
    zpvypoNazev?: string;
}

